/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';

// Components.
import {
  Stack,
  Typography,
  Grid,
  TextField,
  Select,
  Box,
  FormControl,
  InputLabel,
  MenuItem
} from '@mui/material';

import Heading from '../components/heading/Heading';
import Item from '../components/custom/Item';

export default function SolicEmpleo() {
  const inputEls = useRef([])


  const [values, setValues] = useState({
    puesto: '',
    fecha: '',
    salario: 0,
    moneda: ''
  })

  const [valueSelect, setValueSelect] = useState({
    tipoEmpleoSelected: '',
    dispoSelected: '',
    monedaSelected: '',
  })

  const rowTipoEmpleo = [
    {
      Id: '01',
      Nombre: 'FIJO'
    },
    {
      Id: '02',
      Nombre: 'TEMPORAL'
    },
    {
      Id: '03',
      Nombre: 'PASANTE'
    }
  ]

  const rowDisponibilidad = [
    {
      Id: '01',
      Nombre: 'INMEDIATA'
    },
    {
      Id: '02',
      Nombre: 'A CONVENIR'
    },
  ]

  // const rowArea = [
  //   {
  //     Id: 'ND',
  //     Nombre: 'NO DEFINIDO'
  //   },
  //   {
  //     Id: '1',
  //     Nombre: 'ADMINISTRACION'
  //   },
  //   {
  //     Id: '4',
  //     Nombre: 'INFORMATICA'
  //   },
  //   {
  //     Id: '8',
  //     Nombre: 'CARTERA Y COBRO'
  //   },
  //   {
  //     Id: '9',
  //     Nombre: 'CONTABILIDAD'
  //   },
  //   {
  //     Id: '11',
  //     Nombre: 'BODEGA'
  //   },
  //   {
  //     Id: '99',
  //     Nombre: 'PASANTÍAS'
  //   },
  // ]

  const rowMoneda = [
    {
      Id: '01',
      Nombre: 'CÓRDOBAS'
    },
    {
      Id: '02',
      Nombre: 'DÓLARES'
    }
  ]

  const handleChange = (event) => {
    try {
      setValues({
        ...values,
        [event.target.name]: event.target.value
      })
    } catch (error) {
      console.error(error)
    }
  }

  const handleSelectChange = (event) => {
    try {
      setValueSelect({
        ...valueSelect,
        [event.target.name]: event.target.value
      })
    } catch (error) {
      console.error(error)
    }
  }

  const getDateToday = () => {
    const newDate = new Date()
    const day = newDate.getDate().toString().padStart(2, '0')
    const month = (newDate.getMonth() + 1).toString().padStart(2, '0')
    const year = newDate.getFullYear()

    return `${day}/${month}/${year}`
  }

  useEffect(() => {
    try {
      setValues({
        ...values, fecha: getDateToday()
      })
    } catch (error) {
      console.error(error)
    }
  }, [])

  return <div className='App-content'>
    <Heading className='mt-0 w-100 heading justify-content-center'>
      <div className='heading-text text-default'>
        <Stack alignItems='center'>
          <span className='text-decoration-underline fw-bolder'>Solicitud de Empleo</span>
          <Typography component='p' textTransform='none'>
            Sea tan amable de llenar esta solicitud de manera correcta y sincera.
          </Typography>
          <Typography component='p' textTransform='none' className='o-50'>
            Nota: Toda información aquí proporcionada será tratada confidencialmente.
          </Typography>
        </Stack>
      </div>
    </Heading>

    <Typography component='div' width='99%' marginLeft={1} marginY={1}>Datos Generales</Typography>
    <Grid container spacing={1} padding={1} border={1} borderRadius={4}>
      <Grid item xs={12} md={4}>
        <Item>
          <TextField
            id='txtPuesto'
            name='puesto'
            type='text'
            label='Puesto que solicita'
            size='small'
            fullWidth
            onChange={handleChange}
            value={values.puesto}
            inputRef={(el) => (inputEls.current['puesto'] = el)}
            placeholder='Digite el nombre del cargo que solicita'
            required
            InputLabelProps={{
              shrink: true
            }}
          />
        </Item>
        <Item  sx={{ marginTop: 1 }}>
          <Box sx={{ minWidth: 200 }}>
            <FormControl fullWidth size='small'>
              <InputLabel id='TipoLabel' className='text-transform-none'>
                Disponibilidad
              </InputLabel>
              <Select
                id='cboDispo'
                name='dispoSelected'
                label='Disponibilidad'
                value={valueSelect.dispoSelected}
                onChange={handleSelectChange}
                fullWidth
                size='small'
                className='text-start'
                displayEmpty
                required
                inputRef={(el) => (inputEls.current['dispoSelected'] = el)}
              >
                {
                  rowDisponibilidad?.map((item) => {
                    return (
                      <MenuItem key={item.Id} value={item.Id}>{item.Nombre}</MenuItem>
                    )
                  })
                }
              </Select>
            </FormControl>
          </Box>
        </Item>
      </Grid>
      <Grid item xs={12} md={4}>
        <Item>
          <Box sx={{ minWidth: 200 }}>
            <FormControl fullWidth size='small'>
              <InputLabel id='TipoLabel' className='text-transform-none'>
                Tipo de Empleo
              </InputLabel>
              <Select
                id='cboTipoEmpleo'
                name='tipoEmpleoSelected'
                label='Tipo de Empleo'
                value={valueSelect.tipoEmpleoSelected}
                onChange={handleSelectChange}
                fullWidth
                size='small'
                className='text-start'
                displayEmpty
                inputRef={(el) => (inputEls.current['tipoEmpleoSelected'] = el)}
              >
                {
                  rowTipoEmpleo?.map((item) => {
                    return (
                      <MenuItem key={item.Id} value={item.Id}>{item.Nombre}</MenuItem>
                    )
                  })
                }
              </Select>
            </FormControl>
          </Box>
        </Item>
        <Item sx={{ marginTop: 1 }}>
          <TextField
            id='txtSalario'
            name='salario'
            type='number'
            label='Salario que aspira'
            size='small'
            fullWidth
            onChange={handleChange}
            value={values.salario.toFixed(2)}
            inputRef={(el) => (inputEls.current['salario'] = el)}
            placeholder='Digite el salario'
            required
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{
              className: 'text-end fw-bolder'
            }}
          />
        </Item>
      </Grid>
      <Grid item xs={12} md={4}>
        <Item>
          <TextField
            id='txtFecha'
            name='fecha'
            type='text'
            label='Fecha de Solicitud'
            size='small'
            fullWidth
            onChange={handleChange}
            value={values.fecha}
            inputRef={(el) => (inputEls.current['fecha'] = el)}
            required
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              readOnly: true
            }}
          />
        </Item>
        <Item  sx={{ marginTop: 1 }}>
          <Box sx={{ minWidth: 200 }}>
            <FormControl fullWidth size='small'>
              <InputLabel id='TipoLabel' className='text-transform-none'>
                Moneda
              </InputLabel>
              <Select
                id='cboMoneda'
                name='monedaSelected'
                label='Moneda'
                value={valueSelect.monedaSelected}
                onChange={handleSelectChange}
                fullWidth
                size='small'
                className='text-start'
                displayEmpty
                inputRef={(el) => (inputEls.current['monedaSelected'] = el)}
              >
                {
                  rowMoneda?.map((item) => {
                    return (
                      <MenuItem key={item.Id} value={item.Id}>{item.Nombre}</MenuItem>
                    )
                  })
                }
              </Select>
            </FormControl>
          </Box>
        </Item>
      </Grid>
    </Grid>
  </div>
}